import { cache, CACHE_KEYS } from 'tradera-utils/cache';

export default initData => {
    const wishListItemIds = new Set(initData.wishListItemIds || []);
    let recent = cache.read(CACHE_KEYS.RECENTLY_VIEWED_ITEMS) || [];

    //Fix for mapping of url to itemUrl. Only needed for old recent items state visited before 2021-11-16.
    recent = recent.map(({ url, itemUrl, ...item }) => ({
        ...item,
        itemUrl: itemUrl || url
    }));
    return {
        // Items by itemId
        cache: {},
        // List of item ids in ascending cache order (oldest first)
        cacheOrder: [],
        recent,
        wishListItemIds
    };
};
